import { render } from "./CognitoField.vue?vue&type=template&id=49148ef0"
import script from "./CognitoField.vue?vue&type=script&lang=js"
export * from "./CognitoField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__